/**
 * @generated SignedSource<<7e301a273aa70ab772b920c125879e5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespAppliedFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMeasurementUnit_user">;
  readonly " $fragmentType": "SbRespAppliedFilters_user";
};
export type SbRespAppliedFilters_user$key = {
  readonly " $data"?: SbRespAppliedFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespAppliedFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespAppliedFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMeasurementUnit_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b1df331eb05f1806d7eef22f5659a81d";

export default node;
